import { PDP_STOCKLIST_SHOWED } from 'features/product-info/components/pdp-stocks-in-stores/actions';
import { call, put, takeEvery } from 'redux-saga/effects';
import { selectProductPriceCategory } from 'features/product-info';
import { createAction } from 'typesafe-actions';
import { selectProductBelong, selectProductId, selectProductName, selectProductPrice } from './selectors';
import { GaProductBelong } from './types';

/**
 * Cобытие должно срабатывать при раскрытии блока с наличием товаров в других магазинах
 *
 * @see https://docs.google.com/document/d/1Y_vg_aaS7COYvoc4daxezKkWJUiH2Wn-hLAJ9D2ziac/edit#
 */
export const gaClickStocksList = createAction('GA:clickProduct')<{
  elementType: 'button';
  elementBlock: 'productDetail'; // блок, в котором расположен элемент
  elementName: 'availability_store'; // название файла из Media Repository

  productName: string; // название товара
  productId: string; // артикул товара
  productPrice: string; // стоимость единицы товара
  productTag: string; // bestPrice для “Лучшей цены” и onlineOnly для “Только онлайн заказ”, а также остальные бейджи. При наличии нескольких передавать через разделитель “,”
  productBelong: GaProductBelong; // принадлежность товара: LeroyMerlinMarketplace - для товаров Маркетплейс, Longtail - для товаров longtail, LeroyMerlin - для товаров Леруа Мерлен
}>();

export function* putGaClickStocksList() {
  yield put(
    gaClickStocksList({
      elementType: 'button',
      elementBlock: 'productDetail',
      elementName: 'availability_store',
      productName: yield call(selectProductName),
      productId: yield call(selectProductId),
      productPrice: yield call(selectProductPrice),
      productBelong: yield call(selectProductBelong),
      productTag: yield call(selectProductPriceCategory),
    }),
  );
}

export function* runClickStocksListDetector() {
  yield takeEvery(PDP_STOCKLIST_SHOWED, putGaClickStocksList);
}
